module.exports = __webpack_public_path__ + "static/media/banner-promocoes-especias.e6855dbb.png";